"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHullId = exports.Hull = exports.asCategoryId = exports.isCategoryId = exports.Category = void 0;
var Category;
(function (Category) {
    Category.ids = ["SAIL", "POWER"];
})(Category || (exports.Category = Category = {}));
var isCategoryId = function (x) {
    switch (x) {
        case "SAIL":
        case "POWER":
            return true;
        default:
            return false;
    }
};
exports.isCategoryId = isCategoryId;
var asCategoryId = function (x) { return ((0, exports.isCategoryId)(x) ? x : undefined); };
exports.asCategoryId = asCategoryId;
var Hull;
(function (Hull) {
    Hull.ids = ["MONOHULL", "MULTIHULL"];
})(Hull || (exports.Hull = Hull = {}));
var isHullId = function (x) {
    switch (x) {
        case "MONOHULL":
        case "MULTIHULL":
            return true;
        default:
            return false;
    }
};
exports.isHullId = isHullId;
